export interface WorkshopLocation {
  workshopLocationId: string;
  name: string;
  formulaNumberPrefix: string;
  address: string;
}

export const availableWorkshopLocations: WorkshopLocation[] = [
  {
    workshopLocationId: "YesPara",
    name: "Paris",
    formulaNumberPrefix: "GP",
    address: "43 rue de Provence, 75009 Paris",
  },
];

export function adaptPerfumeWorkshopLocation(workshopLocationId: string): WorkshopLocation | null {
  return (
    availableWorkshopLocations.find(
      (workswhop) => workswhop.workshopLocationId === workshopLocationId,
    ) ?? null
  );
}
